/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * What was done.
 */
export type ClientEventDtoAction = typeof ClientEventDtoAction[keyof typeof ClientEventDtoAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientEventDtoAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;
